export async function getCard(id) {
  try {
    const data = await fetch('/api/common/card?id=' + id).then(res => res.json());
    return { cards: data.payload, category: data.category }
  } catch (error) {
    return {card: [], category: {}}
  }
}

export async function downloadAnki(id) {
  try {
    const result = await fetch('/api/auth/params').then(res => res.json());

    const params = result.payload;// microservicesApi
    console.log("🚀 ~ file: actions.js ~ line 13 ~ downloadAnki ~ params", params)
    const data = await fetch(params.microservicesApi + '/anki?token=' + id).then(res => res.json());
    return data
  } catch (error) {
    return null
  }
}


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/CardView/actions.js